module.exports = __webpack_public_path__ + "media/newstyle/images/stars_3-orange-7c9099c746e1aa3fe7e794907e2a554f.svg";